/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileSaverService } from '../file-saver-service/file-saver.service';

const baseUrlPath = '/assets/terms-and-conditions/';
export const FileDownloadType = {
  CUSTOMER_TERMS_OF_SERVICE: `${baseUrlPath}BoldPenguinCustomerTermsOfService-2024Feb.pdf`,
  PRODUCER_AGREEMENT: `${baseUrlPath}BoldPenguinProducerAgreement-2024May.pdf`,
  TERMINAL_TERMS_OF_SERVICE: `${baseUrlPath}BoldPenguinTerminalTermsOfService-2022Nov.pdf`,
};
export interface IFileDownloadService {
  downloadPdf(url: string, filename: string): void;
}

@Injectable({
  providedIn: 'root',
})
export class FileDownloadService implements IFileDownloadService {
  constructor(
    private http: HttpClient,
    private fileSaverService: FileSaverService,
  ) {}

  downloadPdf(url: string, filename: string) {
    this.http
      .get(url, {
        headers: {
          'Content-Type': 'application/pdf',
        },
        responseType: 'blob',
      })
      .subscribe((pdfBlob) => this.fileSaverService.saveAs(pdfBlob, filename));
  }
}
